// 代征平台资料管理
<template>
  <div class="content">
    <!-- start of search -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <!-- 公司名称 -->
          <div class="search-area-div">公司名称</div>
          <el-input size="mini" v-model="page.tenantName" placeholder="请输入" clearable filterable class="ipt-sty">
          </el-input>
        </el-col>
         <el-col :span="6">
          <!-- 账号状态 -->
          <div class="search-area-div">账号类型</div>
          <el-select size="mini"  collapse-tags v-model="page.memberStatusList" placeholder="请选择" clearable filterable class="ipt-sty">
            <el-option v-for="(item) in getCodeListByKey('账号类型')"
              :key="item.guid"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <!-- search btn -->
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- end of search -->

    <!-- start of list -->
    <div class=" back-color-fff content-main-box">
      <div class="button-area p16">
        <el-button size="mini" type="info" @click="addPath">创建代征平台</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" :height="tableHeight" stripe border v-loading="tableLoading" style="width:100%"
        :row-key="(row) => row.guid">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <!-- 公司名称 -->
        <el-table-column prop="tenantName" min-width="180" label="公司名称" header-align="center" align="left" fixed="left" show-overflow-tooltip>
        </el-table-column>
        <!-- 公司简称 -->
        <el-table-column prop="abbreviation" label="公司简称" header-align="center" width="120" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.abbreviation || '-' }}</template>
        </el-table-column>
        <!-- 公司组织形式 -->
        <el-table-column prop="organizationForm" width="120" label="公司组织形式" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ getName(scope.row.organizationForm,'公司组织形式') }}</template>
        </el-table-column>
        <!-- 是否实缴 -->
        <el-table-column prop="isPaidIn" width="96" label="是否实缴" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.isPaidIn == 'Y' ? '是': '否' }}
          </template>
        </el-table-column>
        <!-- 是否垫资 -->
        <el-table-column prop="isAdvanceMoney" width="96" label="是否垫资" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.isAdvanceMoney == 'Y' ? '是': '否' }}
          </template>
        </el-table-column>
        <!-- 证照年审是否政策 -->
        <el-table-column prop="annualReviewState " width="120" label="证照年审是否正常" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.annualReviewState == 'Y' ? '是': '否' }}
          </template>
        </el-table-column>
        <!-- 业务联系人 -->
        <el-table-column prop="contacts " width="120" label="业务联系人" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.contacts || '-' }}
          </template>
        </el-table-column>
        <!-- 业务联系电话 -->
        <el-table-column prop="contactTel " width="120" label="业务联系人电话" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.contactTel || '-'  }}
          </template>
        </el-table-column>
        <!-- 账号类型 -->
        <el-table-column prop="memberStatus " width="96" label="账号类型" header-align="center" align="left">
          <template slot-scope="scope">
            {{ $getNameByKey(scope.row.memberStatus,'账号类型') }}
          </template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column prop="createTime " width="160" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.createTime | getTimeDate }}
          </template>
        </el-table-column>
        <!-- 合同有效期 -->
        <!-- <el-table-column prop="cooperationValidityDate" width="120" label="合同有效期" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="{ color: getAlarmTime(scope.row.cooperationValidityDate,30) ? 'red': '' }">
              {{ scope.row.cooperationValidityDate | getDate }}
            </span>
          </template>
        </el-table-column> -->
       
        <el-table-column label="操作" header-align="center" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="editPath(scope.row.guid)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData( scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>

      <!-- start of pagination -->
      <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="page.pageIndex"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
      </el-pagination>
      <!-- end of pagination -->
    </div>
    <!-- end of list -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 263,
      page: {
        'pageIndex': 1,
        'pageSize': 50,
        'totalPage': 0,
        'totalRows': 0,
        'tenantName': '',
        // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
        'enterpriseCate': '9904',
        // 'enterpriseCates': ['9903', '9904'],
      },
      // 公司名称下拉选数据
      tenantList: [],
      tableData: [],
      tableLoading: false,

    };
  },
  created() {
    this.getData(true);
    this.getTenantDatas();
  },
  beforeRouteEnter (to, from, next) {
    if (from.path === '/maintenanceMgtEdit') {
      next((vm) => {
        vm.getData(true);
      });
    } else {
      next()
    }
  },
  methods: {
    getTenantDatas() {
      let that = this;
      that.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        {
          // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
          "enterpriseCate": '9904',
          // 'enterpriseCates': ['9903', '9904'],
          "pageIndex": 1,
          "pageSize": -1
        }
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // console.log(res.data)
          this.tenantList = res.data.data.records || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(guid) {
      let self = this;
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        self.api.postJson(`/${serverConfig.msCustomerService}/tenant-expand/levy-enterprise-credential/delete`,[guid]).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    empty() {
      let self = this;
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
        // 'enterpriseCate': '9904',
        'enterpriseCates': ['9903', '9904'],
        tenantName: ''
      }

      self.getData(true);
    },
    getData(flg) {
      let self = this;
      let param = JSON.parse(JSON.stringify(self.page))
      param.memberStatusList = param.memberStatusList ? [param.memberStatusList] : []
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant-expand/levy-enterprise-credential/get`, param).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addPath() {
      this.$router.push({
        path: '/maintenanceMgtEdit',
        query: { tenantGuid: this.page.tenantGuid,  productGuid:this.$route.query.productGuid }
      });
    },
    editPath(guid) {
      this.$router.push({
        path: '/maintenanceMgtEdit',
        query: { guid: guid, tenantGuid: this.page.tenantGuid,  productGuid:this.$route.query.productGuid }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.getData();
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    /**
     *
     * 判断是否在某个时间点内
     * date 输入日期(new Date())
     * dayNum 天数
     */
    getAlarmTime(date,dayNum){
      let flag = false
      let contractTime = new Date(date).getTime()
      let currentTime = new Date().getTime()
      let alarmTime = dayNum * 1000 * 24 * 60 * 60
        if ((contractTime - currentTime) <= alarmTime) {
        flag = true
      } else {
        flag = false
      }
    },
  },
};
</script> 

<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #DCDFE6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.content-main-box {
  height: calc(100vh - 60px - 35px - 66px);
}
.el-table {
  border-bottom: 1px solid #D9D9D9;
}
</style>